import { assert_string_object_id, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestCollectionUpdateVisibility extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_COLLECTION_UPDATE_VISIBILITY;

  workspace_id!: string;
  collection_id!: string;
  is_hidden!: boolean;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.collection_id);
    assert_type_boolean(this.is_hidden);
  }
}
